import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import * as HelpMessages from '../../Services/helpMessages';

export const InfoTag = ({ id, lng }) => {
  function getTooltipText(id) {
    const maxAllovedCompetences = 10;
    //#region APPLICATIONS
    if (id === 'allApplications') {
      return HelpMessages.getApplicationsText(lng);
    }
    if (id === 'jobAutomaticApplications') {
      return HelpMessages.getJobAutomaticApplicationsText(lng);
    }
    if (id === 'applicantAutomaticApplications') {
      return HelpMessages.getApplicantAutomaticApplicationsText(lng);
    }
    if (id === 'normalApplications') {
      return HelpMessages.getNormalApplicationsText(lng);
    }
    if (id === 'applicationsFromCompetences') {
      return HelpMessages.getApplicationsFromCompetencesText(lng);
    }
    //#endregion

    //#region JOBS
    else if (id === 'allJobs') {
      return HelpMessages.getJobsText(lng);
    } else if (id === 'jobUrlInfo') {
      return HelpMessages.getJobsURLText(lng);
    } else if (id === 'openJobs') {
      return HelpMessages.getOpenJobsText(lng);
    } else if (id === 'boundedJobs') {
      return HelpMessages.getBoundedJobsText(lng);
    } else if (id === 'fullJobs') {
      return (
        <p>
          {HelpMessages.getBoundedJobsText(lng)}
          {HelpMessages.getOpenJobsText(lng)}
        </p>
      );
    } else if (id === 'jobScore') {
      return HelpMessages.getJobsScoreText(lng);
    } else if (id === 'jobExpirationDate') {
      return HelpMessages.getJobsExpirationDate(lng);
    }
    //#endregion

    //#region APPLICANTS
    else if (id === 'allApplicants') {
      return HelpMessages.getApplicantsText(lng);
    } else if (id === 'openApplicants') {
      return HelpMessages.getOpenApplicantsText(lng);
    } else if (id === 'boundedApplicants') {
      return HelpMessages.getBoundedApplicantsText(lng);
    }
    //#endregion

    //#region COMPETENCES
    else if (id === 'allCompetences' || id === 'allCompetences2') {
      return HelpMessages.getCompetencesText(lng);
      // TODO: solve: if 2 identical ids are on the same page, tooltip does now show for one of them
    } else if (id === 'instructionForCompetences') {
      return HelpMessages.getInstructionsForCompetencesText(maxAllovedCompetences, lng);
    } else if (id === 'positiveScorePart') {
      return HelpMessages.getPositiveScorePartText(lng);
    } else if (id === 'negativeScorePart') {
      return HelpMessages.getNegativeScorePartText(lng);
    } else if (id === 'questionnaireInfo') {
      return HelpMessages.getInstructionsForQuestionnaire(lng);
    }

    //#endregion

    //#region SETTINGS
    else if (id === 'recruitersEmail') {
      return HelpMessages.getRecruitersEmailDescription(lng);
    }
    //#endregion

    //#region WIZARDS
    else if (id === 'openJobMsgForApplicant') {
      return HelpMessages.getOpenJobMsgForApplicant(lng);
    } else if (id === 'boundedJobMsgForApplicant') {
      return HelpMessages.getBoundedJobMsgForApplicant(lng);
    }
    //#endregion

    //#region MISC
    else if (id === 'weightDescription' || id === 'weightDescription2') {
      return HelpMessages.getWeightDescriptionText(lng);
    } else if (id === 'maxPossibleScoreDescription') {
      return HelpMessages.getMaxPossibleScoreText(lng);
    } else if (id === 'commentsShortcut') {
      return HelpMessages.getCommentsShortcutText(lng);
    }
    //#endregion MISC
    else {
      return 'TODO';
    }
  }

  return (
    // NOTE: Useful if you want to add "Info icon". For other cases just use UncontrolledTooltip
    <em id={id} style={{ cursor: 'pointer' }} className="fa mr-2 fas fa-info-circle">
      <UncontrolledTooltip delay={{ show: 300, hide: 0 }} placement="left" target={id}>
        {getTooltipText(id)}
      </UncontrolledTooltip>
    </em>
  );
};
